// extracted by mini-css-extract-plugin
module.exports = {"heroMedia":"HeroStatic-module--heroMedia--34PWw","img":"HeroStatic-module--img--wMgFR"};